let OneStepPanel = require("activity/OneStepActivity/OneStepPanel")
let [TimeModeActivityNoTimePanel, NotimePanelEvent] = require("activity/TimeModeActivity/TimeModeActivityNoTimePanel")
let TimeModeActivityPanel = xClass("TimeModeActivityPanel", OneStepPanel, () => {
    return cc.CSLoader.createNode("cocos/one_step_start_panel.csb")
})
TimeModeActivityPanel.resources = [
    "font/zzgftongxin_40_greenstroke.fnt",
    "font/zzgftongxin_40_aquastroke.fnt",
    "cocos/one_step_start_panel.csb",
    "cocos/one_step_btn_start.csb",
    "cocos/one_step.plist",
]
TimeModeActivityPanel.load = function () {
    return new Promise((resolve, reject) => {
        preloadWithLoading(TimeModeActivityPanel.resources, resolve, reject, reject)
    })
}
TimeModeActivityPanel.prototype.ctor = function (logic, onCloseCallback) {
    let self = this
    OneStepPanel.prototype.ctor.call(self, logic, onCloseCallback)
    self.quesTitleKey = "clover.text.565"
    self.quesContentKey = "time.match.description"
}
TimeModeActivityPanel.prototype.initUI = function () {
    let self = this
    OneStepPanel.prototype.initUI.call(self)
    self.getChildByName("pic").setSpriteFrame("one_step/pic2.png")
    self.getChildByName("title").setSpriteFrame("one_step/title_time_mode.png")
}
TimeModeActivityPanel.prototype.buildMixText = function () {
    let self = this
    let uiTip = self.getChildByName("tip")
    uiTip && uiTip.removeFromParent(true)
    let pre = 0.76
    let width = self.getContentSize().width
    let info = TimeModeActivityManager.getInstance().getInfo()
    const GuideAnims = require("clover/gameGuide/GameGuideAnims")
    self.tips = GuideAnims.createMixedText(
        getText("timemode.startpanel.desc", {
            num: info.targetThreshold
        }),
        27, cc.color(247, 150, 12, 255),
        width * pre
    )
    self.addChild(self.tips)
    self.tips.setPosition(width * (1 - pre) / 2, -420)

    self.bottomTips = GuideAnims.createMixedText(
        getText("time.match.timelimit.text", {
            timelimit: info.nextLevelAddTime ? `${info.timeLimit}+${info.nextLevelAddTime}` : info.timeLimit
        }),
        27, cc.color(255, 64, 0, 255),
        width * pre
    )
    self.addChild(self.bottomTips)
    self.bottomTips.setPosition(width * (1 - pre) / 2, -690)

}
TimeModeActivityPanel.prototype.updateUI = function () {
    let self = this
    let info = TimeModeActivityManager.getInstance().getInfo()
    if (info.leftTimes > 0) {
        self.timeNode.setVisible(true)
        self.timeNode.setString(info.leftTimes)
        self.redBg.setVisible(true)
    } else {
        self.timeNode.setVisible(false)
        self.redBg.setVisible(false)
    }

    // let startTime = formatTime2Str2(info.begin)
    let endtime = formatTime2Str2(info.end)
    self.activityTime.setString(`活动时间：即日起 - ${endtime}`)
    self.activityTime.getVirtualRenderer().setDimensions(450, 0)
    self.activityTime.setContentSize(self.activityTime.getVirtualRendererSize())
    self.activityTime.x = (self._contentSize.width - self.activityTime.getContentSize().width) / 2

    let pic = self.getChildByName("pic")
    let picSize = pic.getContentSize()
    let bg = self.getChildByName("inner_bg")
    let size = cc.size(picSize.width + 2 * 13, picSize.height + 2 * 13)
    bg.setContentSize(size)
    bg.x = (self.getContentSize().width - size.width) / 2
    // pic.setPosition((self.getContentSize().width - picSize.width) / 2, bg.y - (size.height - picSize.height) / 2)
    pic.setPosition(bg.x + 14, bg.y - 13)


    self.tips && self.tips.removeFromParent(true)
    self.bottomTips && self.bottomTips.removeFromParent(true)
    self.buildMixText()
}
TimeModeActivityPanel.prototype.canStartLevel = function () {
    let local = Localhost.time()
    let info = TimeModeActivityManager.getInstance().getInfo()
    if (local >= info.end) {
        return false
    }
    return true
}
TimeModeActivityPanel.prototype.startLevel = function () {
    let self = this
    if (self.isBusy) {
        return
    }
    self.isBusy = true

    let info = TimeModeActivityManager.getInstance().getInfo()
    let [logic, errCode] = require("activity/TimeModeActivity/startEndLevelLogic/StartTimeBlockLevelLogic").create(info.levelId)
    if (!logic) {
        if (errCode === ZooErrorCode.TIME_MODE_ACTIVITY_END) {
            Toast.make(curryQuickGetErrorText(errCode), 1, () => {
                self.isBusy = false
            })
        } else if (errCode === ZooErrorCode.TIME_MODE_TIME_NOT_ENOUGT) {
            self.showOnTimesPanel(() => {
                self.isBusy = false
            })
        }
    } else {
        let callback =  () => {
            logic.start(() => {
                self.isBusy = false
                TimeModeActivityManager.getInstance().updateIcon()
            }, () => {
                self.isBusy = false
            })
        }
        self.onClose(callback, null, true)
        
    }
    DCAssist.dc4User101("timeMode", "click_challenge_btn")
    
}

TimeModeActivityPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this
    BasePanel.prototype.onClose.call(self, () =>{ 
        callback && callback()
        self.onCloseCallback && self.onCloseCallback()
    }, arg, withoutAnim)
}

TimeModeActivityPanel.prototype.showOnTimesPanel = function (callback) {
    let self = this
    TimeModeActivityNoTimePanel.load().then(() => {
        let panel = TimeModeActivityNoTimePanel.create()
        panel.on(NotimePanelEvent.ShareMessage, handler(self, self.onShareMessge))
        panel.popup(true, 0, () => {
            callback && callback()
        })
        panel.on(NotimePanelEvent.Close, () => {
            self.updateUI()
        })
    }).catch(() => {
        Toast.make(curryQuickGetErrorText(0), 1, () => {
            callback && callback()
        })
    })
}
TimeModeActivityPanel.prototype.onShareMessge = function (evt) {
    let self = this
    if (self.isBusy) {
        return
    }
    self.isBusy = true

    function notBusy() {
        // if (evt.dcCb){
        //     evt.dcCb(self.shareTextId);
        // }
        self.isBusy = false
    }

    self.logic.shareNoTimes(notBusy, notBusy, notBusy);;
}
TimeModeActivityPanel.prototype.cleanup = function () {
    BasePanel.prototype.cleanup.call(this)
    ResManager.release(TimeModeActivityPanel.resources)
}
module.exports = TimeModeActivityPanel